import { Component } from 'react';
import { Layout, Tabs } from 'antd';

const { Header } = Layout;
const { TabPane } = Tabs;

class Topbar extends Component {
    render() {
        const {
            activeTabKey,
            setActiveTabKey,
        } = this.props;

        let tabPanes;

        switch (activeTabKey) {
            case 'partner':
                tabPanes = [
                    <TabPane tab="Partner" key="partner" />
                ];
                break;
            default:
                tabPanes = [
                    <TabPane tab="Introduction" key="intro" />,
                    <TabPane tab="MyInvois" key="myinvois" />,
                    <TabPane tab="Sales" key="sales" />,
                    <TabPane tab="Purchase" key="purchase"/>,
                    <TabPane tab="Bank" key="bank"/>,
                    <TabPane tab="Contact" key="contact" />,
                    <TabPane tab="Product" key="product" />,
                    <TabPane tab="Stock" key="stock" />,
                    <TabPane tab="Accounting" key="accounting" />,
                    <TabPane tab="Lists" key="lists" />,
                    <TabPane tab="Files" key="files" />,
                    <TabPane tab="Control Panel" key="control-panel" />
                ];
                break;
        }

        // Changelog is pinned to the far right (via tabBarExtraContent) so it stays
        // visible and never collapses into the overflow "..." menu. Only shown on the
        // main tab set, not the standalone "partner" view.
        const extraContent = activeTabKey === 'partner' ? null : {
            right: (
                <span
                    className={`changelog-tab${activeTabKey === 'changelog' ? ' changelog-tab--active' : ''}`}
                    onClick={() => setActiveTabKey('changelog')}
                >
                    Changelog
                </span>
            )
        };

        return <Header>
            <Tabs activeKey={activeTabKey} onChange={setActiveTabKey} tabBarExtraContent={extraContent}>
                { tabPanes }
            </Tabs>
        </Header>;
    }
}
export default Topbar;
